import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

/**
 * Base Query client for all API endpoints.
 * Used for code generation
 *
 */
export const baseApiClient = createApi({
  baseQuery: baseQueryWithErrorHandling,
  // No tag types required for this utility endpoint
  endpoints: () => ({}),
});
